import { render, staticRenderFns } from "./LiveFeed.vue?vue&type=template&id=1e5847a3&"
import script from "./LiveFeed.vue?vue&type=script&lang=ts&"
export * from "./LiveFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports